import PageLayout from '@/components/feature/PageLayout';
import Pricing from '@/pages/home/components/Pricing';

export default function PricingPage() {
  return (
    <PageLayout>
      <Pricing />
    </PageLayout>
  );
}